
import React from "react";
import BlogCard from "@/components/BlogCard";
import { Link } from "react-router-dom";

interface RelatedPost {
  id: string | number;
  title: string;
  excerpt: string;
  slug: string;
  imageSrc: string;
}

interface RelatedPostsProps {
  posts: RelatedPost[];
}

const RelatedPosts = ({ posts }: RelatedPostsProps) => {
  if (!posts || posts.length === 0) {
    return null;
  }

  return (
    <div className="mt-16">
      <h3 className="text-2xl font-bold mb-6">Related Articles</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
        {posts.map((post) => {
          const blogPostPath = `/blog/${post.slug}/`;

          return (
            <div key={post.id} className="group relative">
              <BlogCard
                title={post.title}
                excerpt={post.excerpt}
                slug={post.slug}
                imageSrc={post.imageSrc}
              />
              {/* Add an invisible full link overlay for better SEO juice */}
              <Link
                to={blogPostPath}
                className="absolute inset-0 z-10"
                aria-label={`Read full article: ${post.title}`}
                title={post.title}
              >
                <span className="sr-only">Read {post.title}</span>
              </Link>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default RelatedPosts;
